import {
  takeLatest, put, call, select
} from 'redux-saga/effects';

import {
  map, reduce, find,
  propEq, isNil, reject
} from 'ramda';

import Utils from 'src/utils';
import { confirmatorsActions, confirmatorActions } from 'src/store/reducers/confirmatorsAdministrationReducer';
import { requestEmployees, loadAllEmployeesSuccess } from 'src/store/actions/employeesActions';
import { selectAllEmployees } from 'src/store/reducers/employeesReducer';
import toastrError from 'src/helpers/toastr/toastrError';
import toastrSuccess from 'src/helpers/toastr/toastrSuccess';
import { wtsApi } from 'src/api';

// eslint-disable-next-line func-names
export default function* () {
  yield [
    takeLatest(confirmatorsActions.request, confirmatorsRequestSaga),

    takeLatest(confirmatorActions.update.request, confirmatorUpdate),
    takeLatest(confirmatorActions.delete.request, confirmatorDelete)
  ];
}

const extendConfirmator = (user, confirmator) => ({
  ...Utils.objects.decapitalizeObject(confirmator),
  user
});

function* confirmatorsRequestSaga(payload) {
  try {
    const confirmatorsResponse = yield call(wtsApi.confirmationUsers.confirmationUsersList, payload);
    const confirmators = confirmatorsResponse.data.Data;
    const employees = yield call(requestEmployees, {});

    const employeesHash = reduce((acc, employee) => {
      acc[employee.UserId] = Utils.objects.decapitalizeObject(employee);
      return acc;
    }, {}, employees);

    const extendedConfirmators = map((confirmator) => extendConfirmator(
      employeesHash[confirmator.UserId],
      confirmator
    ), confirmators);

    yield put(loadAllEmployeesSuccess(employees));

    yield put({
      type: confirmatorsActions.success,
      payload: Utils.objects.normalizeList('id')(map(Utils.objects.decapitalizeObject, extendedConfirmators))
    });
  } catch (e) {
    toastrError(e);
  }
}

function* confirmatorUpdate({ payload: confirmator }) {
  try {
    const { id } = confirmator;

    const apiCall = id
      ? wtsApi.confirmationUsers.confirmationUsersUpdate
      : wtsApi.confirmationUsers.confirmationUsersCreate;

    const respData = yield call(apiCall, confirmatorToParams(confirmator));
    const resp = respData.data;

    const employees = yield select(selectAllEmployees);
    const employee = find(propEq('UserId', resp.Data.UserId), employees);

    const extendedConfirmator = extendConfirmator(
      Utils.objects.decapitalizeObject(employee),
      Utils.objects.decapitalizeObject(resp.Data)
    );

    toastrSuccess(resp);

    yield put({
      type: confirmatorActions.update.success,
      payload: extendedConfirmator
    });
  } catch (e) {
    toastrError(e);
  }
}

const confirmatorToParams = ({
  id,
  userId,
  level,
  reportId,
  ...rest
}) => reject(isNil, {
  Id: id,
  UserId: userId,
  ReportId: reportId || 'MainReport',
  ConfirmationLevel: parseInt(level, 10),
  ...rest
});

function* confirmatorDelete({ payload: id }) {
  try {
    yield call(wtsApi.confirmationUsers.confirmationUsersDelete, { id });

    yield put({
      type: confirmatorActions.delete.success,
      payload: id
    });
  } catch (e) {
    toastrError(e);
  }
}
